<template>
  <div v-if="resource" class="flex flex-col gap-3">
    <div class="bg-white rounded-lg border">
      <Accordion
        id="tech-timeline"
        accordion-type="flush"
        :items="[{ open: expanded }]"
        @expanded="toggleShowBadge"
      >
        <template #content-0-header>
          <div
            class="text-sm flex flex-col gap-4 md:gap-0 md:flex-row-reverse md:justify-between md:items-center w-full"
          >
            <div>
              <TimeBadge
                v-if="showBadge"
                :label="timeBadge.label"
                :time="timeBadge.time"
                :text-only="timeBadge.textOnly || timeBadge.time === '--'"
                :background-color="timeBadge.backgroundColor"
              >
                <template #icon
                  ><component :is="timeBadge.icon"></component
                ></template>
              </TimeBadge>
            </div>
            <ResourceContent :resource="resource" />
          </div>
        </template>
        <template #content-0-body>
          <AppointmentTimeline :appointment="appointment" />
        </template>
      </Accordion>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import Accordion from "@/components/Seranova/Accordion/Accordion.vue";
import TimeBadge from "@/components/Seranova/TimeBadge/TimeBadge.vue";
import { useAppointmentTimes } from "@/AppointmentDetails/useAppointmentTimes";
import ResourceContent from "@/SchedulerV2/ResourceContent.vue";
import { AppointmentV2 } from "@/typings/appointment";
import { TimelineResource } from "@/typings/scheduler";
import { Technician } from "@/typings/technician";
import AppointmentTimeline from "./AppointmentTimeline.vue";

const props = defineProps<{
  technician: Technician;
  appointment: AppointmentV2;
  expanded?: boolean;
}>();
const { timeBadge } = useAppointmentTimes(props);
const showBadge = ref(!props.expanded);

const resource = computed(() => {
  if (!props.technician) return null;
  return new TimelineResource({
    id: props.technician.technician_id,
    name: props.technician?.full_name
  });
});

const toggleShowBadge = () => {
  showBadge.value = !showBadge.value;
};
</script>

<style scoped></style>
